import { ModelComputeOptionEnabled } from "models/ModelCompute";
import { useEffect, useMemo, useState } from "react";

const useModelHierarchies = (
    modelComputeOptions: ModelComputeOptionEnabled[] | null | undefined,
    option: string,
) => {
    const [selectedHierarchies, setSelectedHierarchies] = useState<string[]>(
        [],
    );
    const [runOnAll, setRunOnAll] = useState(false);

    const foundOption = useMemo(() => {
        return modelComputeOptions?.find(
            (i) => i.modelComputeOption.modelOption === option,
        );
    }, [modelComputeOptions, option]);

    const ids = useMemo(() => {
        return foundOption?.modelComputeOption.modelComputeStructureMembers?.map(
            (osm) => osm.organizationStructureMemberId,
        );
    }, [foundOption]);

    useEffect(() => {
        setSelectedHierarchies(ids ?? []);
        setRunOnAll(ids?.length === 0);
    }, [ids]);

    return {
        selectedHierarchies,
        setSelectedHierarchies,
        isEnabled: foundOption?.enabled ?? false,
        setRunOnAll,
        runOnAll,
    };
};

export default useModelHierarchies;
